const VARIANT_STYLES = {
  primary: {
    backgroundColor: "var(--color-primary)",
    color: "#fff",
    border: "none",
  },
  success: {
    backgroundColor: "#19BC31",
    color: "#fff",
    border: "none",
  },
  danger: {
    backgroundColor: "#FF4343",
    color: "#fff",
    border: "none",
  },
  teal: {
    backgroundColor: "#31778C",
    color: "#fff",
    border: "none",
  },
  outline: {
    backgroundColor: "#fff",
    color: "var(--color-primary)",
    border: "2px solid var(--color-primary)",
  },
  ghost: {
    backgroundColor: "#fafafa",
    color: "#45464e",
    border: "1px solid #e0e0e0",
  },
};

export default function InvestorPortalActionButton({
  btnText,
  onClick,
  variant = "outline",
  disabled = false,
  loading = false,
  type = "button",
  fullWidth = true,
}) {
  const style = VARIANT_STYLES[variant] || VARIANT_STYLES.outline;
  const isDisabled = disabled || loading;

  return (
    <button
      type={type}
      className={`investor-portal-action-btn${fullWidth ? "" : " investor-portal-action-btn--inline"}`}
      style={style}
      onClick={onClick}
      disabled={isDisabled}
    >
      {loading ? "Loading..." : btnText}
    </button>
  );
}

export function InvestorPortalActionStack({ children }) {
  return <div className="investor-portal-action-stack">{children}</div>;
}
